<template>
  <img class="help-tooltip" alt="" v-bind:src="getSrc('help.svg')" v-b-tooltip.hover :title="$t(tooltipText)"/>
</template>

<script>
import imageMixin from '@/mixins/image'
export default {
  name: 'HelpTooltip',
  mixins: [imageMixin],
  props: ['tooltipText']
}
</script>
<style lang="scss" scoped>
  .help-tooltip {
    width: 18px;
    height: 18px;
    margin-top: -4px;
    cursor: pointer;
  }
</style>
